import { Fragment } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import Typo from 'constants/typography'
import styles from './styles.scss'

/**
 *
 * @param {string} props.className customize style of component
 * @param {string} props.typo customize font of component
 */
const InformationBoxContent = ({ className, typo, ...rest }) => {
  const classes = clsx('pml-info-box-content', typo || Typo.body2, className)

  return (
    <Fragment>
      <style jsx>{styles}</style>
      <div className={classes} {...rest} />
    </Fragment>
  )
}
InformationBoxContent.defaultProps = {
  className: undefined,
  typo: undefined,
}

InformationBoxContent.propTypes = {
  className: PropTypes.string,
  typo: PropTypes.oneOf(Object.values(Typo)),
}

export default InformationBoxContent
